export default __webpack_public_path__ + "static/cafe_36072-1646b4afc7ac64da97f9da58838674e1.png";